import { createBrowserRouter, Navigate } from 'react-router';

import {
    AddShoppingCart,
    AttachFileOutlined,
    BookOutlined,
    CalendarMonthOutlined,
    CampaignOutlined,
    DisplaySettingsOutlined,
    EqualizerOutlined,
    LocalShippingOutlined,
    MmsOutlined,
    MonetizationOnOutlined,
    RequestQuoteOutlined,
    SettingsOutlined,
    ViewCarouselOutlined,
} from '@mui/icons-material';

import { ArquivoForm, ArquivoList } from 'pages/arquivo';
import { CategoriaForm, CategoriaList } from 'pages/arquivo/categoria';
import { TagFormArquivo, TagListArquivo } from 'pages/arquivo/tag';
import { BannerForm, BannerList } from 'pages/banner';
import { BiForm, BiList } from 'pages/bi';
import { ColunasDinamicasForm, SecaoListColunasDinamicas } from 'pages/cadastro/colunas-dinamicas';
import { LojaForm, LojaList } from 'pages/cadastro/loja';
import { LojaImportacao } from 'pages/cadastro/loja-importacao';
import { PermissoesForm, PermissoesList } from 'pages/cadastro/permissoes';
import { LojaListSecoes, LojaSecaoForm } from 'pages/cadastro/secoes';
import { UsuarioForm, UsuarioList } from 'pages/cadastro/usuario';
import { CalendarioList } from 'pages/calendario';
import { EventoForm, EventoList } from 'pages/calendario/evento';
import { EventoMarcadoresForm, EventoMarcadoresList } from 'pages/calendario/evento/marcadores';
import { BandaPrecoForm, BandaPrecoList } from 'pages/complementar/banda-preco';
import { CargoForm, CargoList } from 'pages/complementar/cargo';
import { CentroCustoForm, CentroCustoList } from 'pages/complementar/centro-custo';
import { CentroDistribuicaoForm, CentroDistribuicaoList } from 'pages/complementar/centro-distribuicao';
import { CentroPedidoForm, CentroPedidoList } from 'pages/complementar/centro-pedido';
import { ClusterForm, ClusterList } from 'pages/complementar/cluster';
import { CondicaoPagamentoForm, CondicaoPagamentoList } from 'pages/complementar/condicao-pagamento';
import { DadosEntregaForm, DadosEntregaList } from 'pages/complementar/dados-entrega';
import { DepositoList, DepositosForm } from 'pages/complementar/depositos';
import { GrupoEmailsForm, GrupoEmailsList } from 'pages/complementar/grupo-emails';
import { LocalFuncionarioForm, LocalFuncionarioList } from 'pages/complementar/local-funcionario';
import { OperacoesForm, OperacoesList } from 'pages/complementar/operacoes';
import { CarrinhoList } from 'pages/compra/carrinho';
import { ConfiguracaoMinimoForm } from 'pages/compra/configuracao-minimo';
import { ConfiguracaoPedidoCompraForm, ConfiguracaoPedidoCompraList } from 'pages/compra/configuracao-pedido';
import { PagamentoForm } from 'pages/compra/pagamento';
import { PedidoCompraList } from 'pages/compra/pedido';
import { PedidoLoteCompraList } from 'pages/compra/pedido-lote';
import { PedidoRealizadoList } from 'pages/compra/pedido-realizado';
import { PedidoTotalizadorList } from 'pages/compra/pedido-totalizador';
import { StatusIntegracaoList } from 'pages/compra/pedido-totalizador/status-integracao';
import { PercentualNotaFiscalList } from 'pages/compra/percentual-nota-fiscal';
import { ProdutoList } from 'pages/compra/produto';
import { SugestaoCompraList } from 'pages/compra/sugestao';
import { TabelaPrecoList } from 'pages/compra/tabela-preco';
import { ComunicadoDetail, ComunicadoForm, ComunicadoList } from 'pages/comunicado';
import { CategoriaComunicadoForm, CategoriaComunicadoList } from 'pages/comunicado/categoria';
import { TagFormComunicado, TagListComunicado } from 'pages/comunicado/tag';
import { EstatisticasList } from 'pages/estatisticas';
import { DetalhamentoCreditoDetail, DetalhamentoCreditoList } from 'pages/financeiro/detalhamento-creditos';
import { DetalhamentoCreditosImportacao } from 'pages/financeiro/detalhamento-creditos/importar';
import { DreForm, DreList } from 'pages/financeiro/dre';
import { DreConfigForm } from 'pages/financeiro/dre/configuracao';
import { PreenchimentoList } from 'pages/financeiro/dre/preenchimento';
import { DreRelatorio } from 'pages/financeiro/dre/relatorio';
import { ExtratoFppList } from 'pages/financeiro/extrato/fpp';
import { EspelhoFppList } from 'pages/financeiro/extrato/fpp-espelho';
import { FppEspelhoNotaProdutoDetail } from 'pages/financeiro/extrato/fpp-espelho-nota-produto';
import { ExtratoRoyaltyList } from 'pages/financeiro/extrato/royalty';
import { EspelhoRoyaltyList } from 'pages/financeiro/extrato/royalty-espelho';
import { NotaProdutoDetail } from 'pages/financeiro/extrato/royalty-espelho-nota-produto';
import { MovimentacaoList } from 'pages/financeiro/nota';
import { NotaDevolucaoForm, NotaDevolucaoList } from 'pages/financeiro/nota-devolucao';
import { MotivoDevolucaoForm, MotivoDevolucaoList } from 'pages/financeiro/nota-devolucao/motivo';
import { RecebiveisPage } from 'pages/financeiro/recebiveis';
import { ConsultaReembolsoList } from 'pages/financeiro/reembolso/consulta-reembolso';
import { GerarReembolsoList } from 'pages/financeiro/reembolso/gerar-reembolso';
import { ManutencaoReembolsoList } from 'pages/financeiro/reembolso/manutencao-reembolso';
import { TituloList } from 'pages/financeiro/titulo';
import { FontesForm, FontesList } from 'pages/fontes';
import { GrupoEconomicoForm, GrupoEconomicoList } from 'pages/grupo-economico';
import { InicioDetail } from 'pages/inicio';
import { Layout } from 'pages/Layout';
import { GradeExclusao, GradeForm, GradeImportacao, GradeList } from 'pages/logistica/grade';
import { QuebrasList } from 'pages/logistica/quebras';
import { SellersVtexList } from 'pages/logistica/sellers-vetex';
import {
    MarketingCampanhaForm,
    MarketingCampanhaList,
    MarketingDetail,
    MarketingEdicaoPecas,
    MarketingForm,
    MarketingList,
} from 'pages/marketing-trade/marketing';
import { TagFormMarketing, TagListMarketing } from 'pages/marketing-trade/marketing/tag';
import { TradeCampanhaForm, TradeCampanhaList, TradeDetail, TradeEdicaoPecas, TradeForm, TradeList } from 'pages/marketing-trade/trade';
import {
    TradeSolicitacaoPecaMensagemForm,
    TradeSolicitacoesPecasForm,
    TradeSolicitacoesPecasList,
} from 'pages/marketing-trade/trade/solicitacoes-pecas';
import { MensagemPadraoForm, MensagemPadraoList } from 'pages/marketing-trade/trade/solicitacoes-pecas/mensagem-padrao';
import { TagFormTrade, TagListTrade } from 'pages/marketing-trade/trade/tag';
import { Page404 } from 'pages/Page404';
import { PredefinicaoEstiloForm, PredefinicoesEstiloList } from 'pages/predefinicoes-estilo';
import { ConfiguracaoGeralForm } from 'pages/revendedor/configuracao-geral';
import { PromocaoList } from 'pages/revendedor/promocao';
import { RevendedorForm, RevendedorList } from 'pages/revendedor/revendedor';

export const router = createBrowserRouter([
    { path: 'login', element: <Navigate to="/" replace /> }, // evitar tela de 404 caso usuário tenha rota de login salva (não existe mais após Keycloak)
    { path: '*', element: <Page404 /> },
    {
        path: '/',
        element: <Layout />,
        children: [
            { index: true, element: <InicioDetail /> },
            {
                path: 'comunicado',

                handle: {
                    menu: {
                        title: 'Comunicados',
                        icon: <CampaignOutlined />,
                        permissions: ['COMUNICADO_VISUALIZAR'],
                    },
                },

                children: [
                    { index: true, element: <ComunicadoList /> },
                    { path: ':id', element: <ComunicadoDetail /> },
                    { path: 'form/:id?', element: <ComunicadoForm /> },
                    {
                        path: 'categoria',
                        children: [
                            { index: true, element: <CategoriaComunicadoList /> },
                            { path: 'form/:id?', element: <CategoriaComunicadoForm /> },
                        ],
                    },
                    {
                        path: 'tag',
                        children: [
                            { index: true, element: <TagListComunicado /> },
                            { path: 'form/:id?', element: <TagFormComunicado /> },
                        ],
                    },
                ],
            },
            {
                path: 'calendario',

                handle: {
                    menu: {
                        title: 'Calendário',
                        icon: <CalendarMonthOutlined />,
                        permissions: ['CALENDARIO_VISUALIZAR'],
                    },
                },

                children: [
                    { index: true, element: <CalendarioList /> },
                    {
                        path: 'evento',
                        children: [
                            { index: true, element: <EventoList /> },
                            { path: 'form/:id?', element: <EventoForm /> },
                        ],
                    },
                    {
                        path: 'marcadores',
                        children: [
                            { index: true, element: <EventoMarcadoresList /> },
                            { path: 'form/:id?', element: <EventoMarcadoresForm /> },
                        ],
                    },
                ],
            },
            {
                path: 'compra',

                handle: {
                    menu: {
                        title: 'Pedido de Compra',
                        icon: <RequestQuoteOutlined />,
                    },
                },

                children: [
                    {
                        path: 'pedido',
                        element: <PedidoCompraList />,

                        handle: {
                            menu: {
                                title: 'Novo Pedido',
                                permissions: ['COMPRA_PEDIDO_VISUALIZAR'],
                                group: 1,
                            },
                        },
                    },
                    {
                        path: 'carrinho',
                        element: <CarrinhoList />,

                        handle: {
                            menu: {
                                title: 'Meu Carrinho',
                                permissions: ['COMPRA_PEDIDO_VISUALIZAR'],
                                group: 1,
                            },
                        },
                    },
                    {
                        path: 'pedido-lote',
                        element: <PedidoLoteCompraList />,

                        handle: {
                            menu: {
                                title: 'Pedidos em Lote',
                                permissions: ['COMPRA_PEDIDO_LOTE_VISUALIZAR'],
                                group: 1,
                            },
                        },
                    },
                    {
                        path: 'pedido-totalizador',

                        handle: {
                            menu: {
                                title: 'Pedidos Totalizadores',
                                permissions: ['COMPRA_PEDIDO_TOTALIZADOR_VISUALIZAR'],
                                group: 1,
                            },
                        },

                        children: [
                            { index: true, element: <PedidoTotalizadorList /> },
                            { path: 'status-integracao', element: <StatusIntegracaoList /> },
                        ],
                    },
                    {
                        path: 'pedido-realizado',
                        element: <PedidoRealizadoList />,

                        handle: {
                            menu: {
                                title: 'Consulta de Pedidos',
                                permissions: ['COMPRA_PEDIDO_LISTAGEM_VISUALIZAR'],
                                group: 2,
                            },
                        },
                    },
                    {
                        path: 'produto',
                        element: <ProdutoList />,

                        handle: {
                            menu: {
                                title: 'Consulta de Produtos',
                                permissions: ['COMPRA_PRODUTO_VISUALIZAR'],
                                group: 2,
                            },
                        },
                    },
                    {
                        path: 'tabela-preco',
                        element: <TabelaPrecoList />,

                        handle: {
                            menu: {
                                title: 'Tabelas de Preços',
                                permissions: ['COMPRA_TABELA_PRECO_VISUALIZAR'],
                                group: 2,
                            },
                        },
                    },
                    {
                        path: 'configuracao-pedido',

                        handle: {
                            menu: {
                                title: 'Configuração de Pedido',
                                permissions: ['COMPRA_PEDIDO_CONFIGURACAO_VISUALIZAR'],
                                group: 3,
                            },
                        },

                        children: [
                            { index: true, element: <ConfiguracaoPedidoCompraList /> },
                            { path: 'form/:id?', element: <ConfiguracaoPedidoCompraForm /> },
                        ],
                    },
                    {
                        path: 'percentual-nota-fiscal',
                        element: <PercentualNotaFiscalList />,

                        handle: {
                            menu: {
                                title: 'Percentual de Nota Fiscal',
                                permissions: ['COMPRA_PERCENTUAL_NOTA_FISCAL_VISUALIZAR'],
                                group: 3,
                            },
                        },
                    },
                    {
                        path: 'sugestao',
                        element: <SugestaoCompraList />,

                        handle: {
                            menu: {
                                title: 'Sugestão de Compra',
                                permissions: ['COMPRA_SUGESTAO_VISUALIZAR'],
                                group: 3,
                            },
                        },
                    },
                    { path: 'pagamento', element: <PagamentoForm /> },
                    { path: 'configuracao-minimo', element: <ConfiguracaoMinimoForm /> },
                ],
            },
            {
                path: 'financeiro',

                handle: {
                    menu: {
                        title: 'Financeiro',
                        icon: <MonetizationOnOutlined />,
                    },
                },

                children: [
                    {
                        path: 'titulos',
                        element: <TituloList />,

                        handle: {
                            menu: {
                                title: 'Consulta de Títulos',
                                permissions: ['FINANCEIRO_TITULO_VISUALIZAR'],
                                group: 1,
                            },
                        },
                    },
                    {
                        path: 'nota',
                        element: <MovimentacaoList />,

                        handle: {
                            menu: {
                                title: 'Consulta de Notas Fiscais',
                                permissions: ['FINANCEIRO_NOTA_FISCAL_VISUALIZAR'],
                                group: 1,
                            },
                        },
                    },
                    {
                        path: 'dre',

                        handle: {
                            menu: {
                                title: 'Estimativa de Resultado',
                                permissions: ['FINANCEIRO_DRE_VISUALIZAR'],
                                group: 1,
                            },
                        },

                        children: [
                            { index: true, element: <DreList /> },
                            { path: 'form/:id?', element: <DreForm /> },
                            { path: 'relatorio/:categoria', element: <DreRelatorio /> },
                            { path: 'preenchimento', element: <PreenchimentoList /> },
                            { path: 'configuracao', element: <DreConfigForm /> },
                        ],
                    },
                    {
                        path: 'extrato/royalty',

                        handle: {
                            menu: {
                                title: 'Extrato de Royalties e FPP',
                                permissions: ['FINANCEIRO_EXTRATO_ROYALTIES_VISUALIZAR'],
                                group: 2,
                            },
                        },

                        children: [
                            { index: true, element: <ExtratoRoyaltyList /> },
                            {
                                path: 'espelho',
                                children: [
                                    { index: true, element: <EspelhoRoyaltyList /> },
                                    { path: 'nota-produto', element: <NotaProdutoDetail /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'extrato/fpp',
                        children: [
                            { index: true, element: <ExtratoFppList /> },
                            {
                                path: 'espelho',
                                children: [
                                    { index: true, element: <EspelhoFppList /> },
                                    { path: 'nota-produto', element: <FppEspelhoNotaProdutoDetail /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'detalhamento-creditos',

                        handle: {
                            menu: {
                                title: 'Detalhamento de Créditos',
                                permissions: ['FINANCEIRO_DETALHAMENTO_CREDITO_VISUALIZAR'],
                                group: 2,
                            },
                        },

                        children: [
                            { index: true, element: <DetalhamentoCreditoList /> },
                            { path: 'detalhes', element: <DetalhamentoCreditoDetail /> },
                            { path: 'importar', element: <DetalhamentoCreditosImportacao /> },
                        ],
                    },
                    {
                        path: 'recebiveis',
                        element: <RecebiveisPage />,

                        handle: {
                            menu: {
                                title: 'Recebíveis E-commerce',
                                permissions: ['FINANCEIRO_RECEBIVEIS_VISUALIZAR'],
                                group: 2,
                            },
                        },
                    },
                    {
                        path: 'nota-devolucao',

                        handle: {
                            menu: {
                                title: 'Simulador de Nota Fiscal de Devolução',
                                permissions: ['FINANCEIRO_DEVOLUCAO_VISUALIZAR'],
                                group: 3,
                            },
                        },

                        children: [
                            { index: true, element: <NotaDevolucaoList /> },
                            { path: 'form/:id?', element: <NotaDevolucaoForm /> },
                            { path: 'motivo', element: <MotivoDevolucaoList /> },
                            { path: 'motivo/form/:id?', element: <MotivoDevolucaoForm /> },
                        ],
                    },
                    {
                        handle: {
                            menu: {
                                title: 'Reembolso de Promoções',
                                group: 4,
                            },
                        },

                        children: [
                            {
                                path: 'consulta-reembolso',
                                element: <ConsultaReembolsoList />,

                                handle: {
                                    menu: {
                                        title: 'Consulta de Reembolsos',
                                        permissions: ['FINANCEIRO_REEMBOLSO_CONSULTAR'],
                                    },
                                },
                            },
                            {
                                path: 'gerar-reembolso',
                                element: <GerarReembolsoList />,

                                handle: {
                                    menu: {
                                        title: 'Gerar Reembolso',
                                        permissions: ['FINANCEIRO_REEMBOLSO_GERAR'],
                                    },
                                },
                            },
                            {
                                path: 'manutencao-reembolso',
                                element: <ManutencaoReembolsoList />,

                                handle: {
                                    menu: {
                                        title: 'Manutenção/Download de Reembolsos',
                                        permissions: ['FINANCEIRO_REEMBOLSO_MANUTENCAO'],
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                path: 'marketing',

                handle: {
                    menu: {
                        title: 'Marketing',
                        icon: <MmsOutlined />,
                    },
                },

                children: [
                    {
                        index: true,
                        element: <MarketingList />,

                        handle: {
                            menu: {
                                title: 'Campanhas e Peças',
                                permissions: ['MARKETING_PECA_VISUALIZAR'],
                            },
                        },
                    },
                    { path: ':id', element: <MarketingDetail /> },
                    { path: 'form/:id?', element: <MarketingForm /> },
                    { path: 'form/:id?/edicao', element: <MarketingEdicaoPecas /> },
                    { path: 'campanha', element: <MarketingCampanhaList /> },
                    { path: 'campanha/form/:id?', element: <MarketingCampanhaForm /> },
                    { path: 'tag', element: <TagListMarketing /> },
                    { path: 'tag/form/:id?', element: <TagFormMarketing /> },
                ],
            },
            {
                path: 'trade',

                handle: {
                    menu: {
                        title: 'Trade',
                        icon: <DisplaySettingsOutlined />,
                    },
                },

                children: [
                    {
                        index: true,
                        element: <TradeList />,

                        handle: {
                            menu: {
                                title: 'Campanhas e Peças',
                                permissions: ['TRADE_PECA_VISUALIZAR'],
                            },
                        },
                    },
                    { path: ':id', element: <TradeDetail /> },
                    { path: 'form/:id?', element: <TradeForm /> },
                    { path: 'form/:id/edicao', element: <TradeEdicaoPecas /> },
                    {
                        path: 'campanha',
                        children: [
                            { index: true, element: <TradeCampanhaList /> },
                            { path: 'form/:id?', element: <TradeCampanhaForm /> },
                        ],
                    },
                    {
                        path: 'solicitacoes-pecas',

                        handle: {
                            menu: {
                                title: 'Solicitações de Peças',
                                permissions: ['TRADE_SOLICITACAO_PECA_VISUALIZAR'],
                            },
                        },

                        children: [
                            { index: true, element: <TradeSolicitacoesPecasList /> },
                            { path: 'form', element: <TradeSolicitacoesPecasForm /> },
                            { path: 'form/:id?', element: <TradeSolicitacaoPecaMensagemForm /> },
                            {
                                path: 'mensagem-padrao',
                                children: [
                                    { index: true, element: <MensagemPadraoList /> },
                                    { path: 'form/:id?', element: <MensagemPadraoForm /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'tag',
                        children: [
                            { index: true, element: <TagListTrade /> },
                            { path: 'form/:id?', element: <TagFormTrade /> },
                        ],
                    },
                ],
            },
            {
                path: 'revendedor',

                handle: {
                    menu: {
                        title: 'Revendedores',
                        icon: <AddShoppingCart />,
                    },
                },

                children: [
                    {
                        path: 'configuracao-geral',
                        element: <ConfiguracaoGeralForm />,
                        handle: {
                            menu: {
                                title: 'Configurações Gerais',
                                permissions: ['REVENDEDOR_CADASTRO_CONFIGURACOES'],
                            },
                        },
                    },
                    {
                        index: true,
                        element: <RevendedorList />,

                        handle: {
                            menu: {
                                title: 'Revendedores',
                                permissions: ['REVENDEDOR_CADASTRO_REVENDEDOR'],
                            },
                        },
                    },
                    { path: 'form/:id?', element: <RevendedorForm /> },
                    {
                        path: 'promocao',
                        element: <PromocaoList />,

                        handle: {
                            menu: {
                                title: 'Promoções',
                                permissions: ['REVENDEDOR_CADASTRO_PROMOCAO'],
                            },
                        },
                    },
                ],
            },
            {
                path: 'banner',

                handle: {
                    menu: {
                        title: 'Banners',
                        icon: <ViewCarouselOutlined />,
                        permissions: ['BANNER_VISUALIZAR'],
                    },
                },

                children: [
                    { index: true, element: <BannerList /> },
                    { path: 'form/:id?', element: <BannerForm /> },
                ],
            },
            {
                path: 'cadastro',

                handle: {
                    menu: {
                        title: 'Cadastro',
                        icon: <BookOutlined />,
                        permissions: ['CADASTRO_VISUALIZAR'],
                    },
                },

                children: [
                    {
                        path: 'loja',

                        handle: {
                            menu: {
                                title: 'Loja',
                                permissions: ['LOJA_VISUALIZAR'],
                            },
                        },

                        children: [
                            { index: true, element: <LojaList /> },
                            { path: 'form/:id?', element: <LojaForm /> },
                            { path: 'importacao', element: <LojaImportacao /> },
                        ],
                    },
                    {
                        path: 'secoes',
                        children: [
                            {
                                path: ':idLoja',
                                children: [
                                    { index: true, element: <LojaListSecoes /> },
                                    { path: 'form/:id?', element: <LojaSecaoForm /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'colunas',
                        children: [
                            {
                                path: ':idSecao',
                                children: [
                                    { index: true, element: <SecaoListColunasDinamicas /> },
                                    { path: 'form/:id?', element: <ColunasDinamicasForm /> },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'permissoes',

                        handle: {
                            menu: {
                                title: 'Grupos de Permissões',
                                permissions: ['GRUPO_PERMISSAO_VISUALIZAR'],
                            },
                        },

                        children: [
                            { index: true, element: <PermissoesList /> },
                            { path: 'form/:id?', element: <PermissoesForm /> },
                        ],
                    },
                    {
                        path: 'usuario',

                        handle: {
                            menu: {
                                title: 'Usuários',
                                permissions: ['USUARIO_VISUALIZAR'],
                            },
                        },

                        children: [
                            { index: true, element: <UsuarioList /> },
                            { path: 'form/:id?', element: <UsuarioForm /> },
                        ],
                    },
                ],
            },
            {
                path: 'complementar',

                handle: {
                    menu: {
                        title: 'Complementar',
                        icon: <SettingsOutlined />,
                    },
                },

                children: [
                    {
                        path: 'banda-preco',

                        handle: {
                            menu: {
                                title: 'Bandas de Preços',
                                permissions: ['COMPLEMENTAR_BANDA_PRECO_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <BandaPrecoList /> },
                            { path: 'form/:id?', element: <BandaPrecoForm /> },
                        ],
                    },
                    {
                        path: 'cargo',

                        handle: {
                            menu: {
                                title: 'Cargos e Créditos',
                                permissions: ['COMPLEMENTAR_CARGO_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <CargoList /> },
                            { path: 'form/:id?', element: <CargoForm /> },
                        ],
                    },
                    {
                        path: 'centro-custos',

                        handle: {
                            menu: {
                                title: 'Centros de Custos',
                                permissions: ['COMPLEMENTAR_CENTRO_CUSTO_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <CentroCustoList /> },
                            { path: 'form/:id?', element: <CentroCustoForm /> },
                        ],
                    },
                    {
                        path: 'centro-distribuicao',

                        handle: {
                            menu: {
                                title: 'Centros de Distribuição',
                                permissions: ['COMPLEMENTAR_CENTRO_DISTRIBUICAO_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <CentroDistribuicaoList /> },
                            { path: 'form/:id?', element: <CentroDistribuicaoForm /> },
                        ],
                    },
                    {
                        path: 'centro-pedidos',

                        handle: {
                            menu: {
                                title: 'Centros de Pedidos',
                                permissions: ['COMPLEMENTAR_CENTRO_PEDIDO_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <CentroPedidoList /> },
                            { path: 'form/:id?', element: <CentroPedidoForm /> },
                        ],
                    },
                    {
                        path: 'condicao-pagamento',

                        handle: {
                            menu: {
                                title: 'Condições de Pagamento',
                                permissions: ['COMPLEMENTAR_CONDICAO_PAGAMENTO_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <CondicaoPagamentoList /> },
                            { path: 'form/:id?', element: <CondicaoPagamentoForm /> },
                        ],
                    },
                    {
                        path: 'configuracao-bi',

                        handle: {
                            menu: {
                                title: 'Configuração de Painéis de BI',
                                permissions: ['COMPLEMENTAR_CONFIG_BI'],
                            },
                        },

                        children: [
                            { index: true, element: <BiList /> },
                            { path: 'form/:id?', element: <BiForm /> },
                        ],
                    },
                    {
                        path: 'depositos',

                        handle: {
                            menu: {
                                title: 'Depósitos',
                                permissions: ['COMPLEMENTAR_DEPOSITO_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <DepositoList /> },
                            { path: 'form/:id?', element: <DepositosForm /> },
                        ],
                    },
                    {
                        path: 'dados-entrega',

                        handle: {
                            menu: {
                                title: 'Fretes e Prazos',
                                permissions: ['COMPLEMENTAR_FRETE_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <DadosEntregaList /> },
                            { path: 'form/:id?', element: <DadosEntregaForm /> },
                        ],
                    },
                    {
                        path: 'grupo-emails',

                        handle: {
                            menu: {
                                title: 'Grupos de E-mails',
                                permissions: ['COMPLEMENTAR_GRUPO_EMAIL_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <GrupoEmailsList /> },
                            { path: 'form/:id?', element: <GrupoEmailsForm /> },
                        ],
                    },
                    {
                        path: 'cargo',
                        children: [
                            { index: true, element: <CargoList /> },
                            { path: 'form/:id?', element: <CargoForm /> },
                        ],
                    },
                    {
                        path: 'cluster',
                        children: [
                            { index: true, element: <ClusterList /> },
                            { path: 'form/:id?', element: <ClusterForm /> },
                        ],
                    },
                    {
                        path: 'depositos',
                        children: [
                            { index: true, element: <DepositoList /> },
                            { path: 'form/:id?', element: <DepositosForm /> },
                        ],
                    },
                    {
                        path: 'centro-pedidos',
                        children: [
                            { index: true, element: <CentroPedidoList /> },
                            { path: 'form/:id?', element: <CentroPedidoForm /> },
                        ],
                    },
                    {
                        path: 'centro-distribuicao',
                        children: [
                            { index: true, element: <CentroDistribuicaoList /> },
                            { path: 'form/:id?', element: <CentroDistribuicaoForm /> },
                        ],
                    },
                    {
                        path: 'condicao-pagamento',
                        children: [
                            { index: true, element: <CondicaoPagamentoList /> },
                            { path: 'form/:id?', element: <CondicaoPagamentoForm /> },
                        ],
                    },
                    {
                        path: 'operacoes',
                        children: [
                            { index: true, element: <OperacoesList /> },
                            { path: 'form/:id?', element: <OperacoesForm /> },
                        ],
                    },
                    {
                        path: 'centro-custos',
                        children: [
                            { index: true, element: <CentroCustoList /> },
                            { path: 'form/:id?', element: <CentroCustoForm /> },
                        ],
                    },
                    {
                        path: 'banda-preco',
                        children: [
                            { index: true, element: <BandaPrecoList /> },
                            { path: 'form/:id?', element: <BandaPrecoForm /> },
                        ],
                    },
                    {
                        path: 'local-funcionario',

                        handle: {
                            menu: {
                                title: 'Locais de Funcionário',
                                permissions: ['COMPLEMENTAR_LOCAL_FUNCIONARIO'],
                            },
                        },

                        children: [
                            { index: true, element: <LocalFuncionarioList /> },
                            { path: 'form/:id?', element: <LocalFuncionarioForm /> },
                        ],
                    },
                    {
                        path: 'operacoes',

                        handle: {
                            menu: {
                                title: 'Operações',
                                permissions: ['COMPLEMENTAR_OPERACAO_GERENCIAR'],
                            },
                        },

                        children: [
                            { index: true, element: <OperacoesList /> },
                            { path: 'form/:id?', element: <OperacoesForm /> },
                        ],
                    },
                ],
            },
            {
                path: 'logistica',

                handle: {
                    menu: {
                        title: 'Logística',
                        icon: <LocalShippingOutlined />,
                    },
                },

                children: [
                    {
                        path: 'grade',

                        handle: {
                            menu: {
                                title: 'Grade',
                                permissions: ['GRADE_VISUALIZAR'],
                            },
                        },

                        children: [
                            { index: true, element: <GradeList /> },
                            { path: 'form/:id?', element: <GradeForm /> },
                            { path: 'importacao', element: <GradeImportacao /> },
                            { path: 'exclusao', element: <GradeExclusao /> },
                        ],
                    },
                    {
                        path: 'quebras',
                        element: <QuebrasList />,

                        handle: {
                            menu: {
                                title: 'Quebras',
                                permissions: ['QUEBRAS_VISUALIZAR'],
                            },
                        },
                    },
                    {
                        path: 'sellers-vtex',
                        element: <SellersVtexList />,

                        handle: {
                            menu: {
                                title: 'Sellers VTEX',
                                permissions: ['LOGISTICA_SELLER_GERENCIAR'],
                            },
                        },
                    },
                ],
            },
            {
                path: 'arquivo',

                handle: {
                    menu: {
                        title: 'Arquivos',
                        icon: <AttachFileOutlined />,
                        permissions: ['ARQUIVO_VISUALIZAR'],
                    },
                },

                children: [
                    { index: true, element: <ArquivoList /> },
                    { path: 'form/:id?', element: <ArquivoForm /> },
                    {
                        path: 'categoria',
                        children: [
                            { index: true, element: <CategoriaList /> },
                            { path: 'form/:id?', element: <CategoriaForm /> },
                        ],
                    },
                    {
                        path: 'tag',
                        children: [
                            { index: true, element: <TagListArquivo /> },
                            { path: 'form/:id?', element: <TagFormArquivo /> },
                        ],
                    },
                ],
            },
            {
                path: 'estatistica',
                element: <EstatisticasList />,

                handle: {
                    menu: {
                        title: 'Estatísticas',
                        icon: <EqualizerOutlined />,
                        permissions: ['ESTATISTICA_VISUALIZAR'],
                    },
                },
            },
            {
                path: 'grupo-economico',
                children: [
                    { index: true, element: <GrupoEconomicoList /> },
                    { path: 'form/:id?', element: <GrupoEconomicoForm /> },
                ],
            },
            {
                path: 'fontes',
                children: [
                    { index: true, element: <FontesList /> },
                    { path: 'form/:id?', element: <FontesForm /> },
                ],
            },
            {
                path: 'predefinicoes-estilo',
                children: [
                    { index: true, element: <PredefinicoesEstiloList /> },
                    { path: 'form/:id?', element: <PredefinicaoEstiloForm /> },
                ],
            },
        ],
    },
]);
